import { createAction } from 'redux-actions';
import { SelectedAgreement } from './selected-agreement.types';

export const setSelectedAgreement = createAction<SelectedAgreement>('SET_SELECTED_AGREEMENT');
export const removeSelectedAgreement = createAction('REMOVE_SELECTED_AGREEMENT');